import { Receipt, ShieldCheck, Truck, Zap } from 'lucide-react';
import TrustpilotWidget from '../v2/common/trustpilot/TrustpilotWidget';
import i18n from '@/settings/i18n';

const t = i18n.init('buyback');

const CONTENT = [
  {
    title: `Get your Quote`,
    icon: <Zap className="h-4 w-4 shrink-0" strokeWidth={1.5} />,
  },
  {
    title: 'Ship for Free',
    icon: <Truck className="h-4 w-4 shrink-0" strokeWidth={1.5} />,
  },
  {
    title: 'Data Wiped',
    icon: <ShieldCheck className="h-4 w-4 shrink-0" strokeWidth={1.5} />,
  },
  {
    title: `Get Paid Fast`,
    icon: <Receipt className="h-4 w-4 shrink-0" strokeWidth={1.5} />,
  },
];

const TradeInSubhero = () => (
  <div className="bg-white text-xs lg:border-b">
    <div className="lg:reebelo-container flex flex-col items-center justify-between lg:flex-row">
      <div className="flex w-full items-start gap-3 px-4 py-2 lg:h-10 lg:w-auto lg:items-center lg:gap-6 lg:p-0">
        {CONTENT.map((item) => (
          <div
            key={item.title}
            className="flex flex-1 flex-col items-center justify-center gap-1 text-center xs:flex-auto xs:flex-row xs:text-left"
          >
            <div className="flex h-6 w-6 items-center justify-center rounded bg-[#ECFCF5]">
              {item.icon}
            </div>
            <div className="max-w-[50px] xxs:max-w-full">{t(item.title)}</div>
          </div>
        ))}
      </div>

      <TrustpilotWidget className="flex w-full items-center justify-center bg-[#F2F2F259] p-2 lg:w-auto lg:bg-transparent lg:p-0" />
    </div>
  </div>
);

export default TradeInSubhero;
